import { FETCH_TV_KEY, ADD_TV_KEY, EDIT_TV_KEY, DELETE_TV_KEY } from '../actionTypes';
import { TV_KEYS } from '../config/index';

const getItems = (state = [], action) => {
    switch (action.type) {
        
        case FETCH_TV_KEY:
            state = [];
            return [...state, ...action.payload];
        
        case ADD_TV_KEY:
            let currentState;
            if (TV_KEYS.LIMIT === state.length) {
                state.pop();
                currentState = state;
            } else {
                currentState = state;
            }
            return [action.payload, ...currentState];
        
        case EDIT_TV_KEY:
            return state.map(tvKey => {
                    if (tvKey.id === action.payload.id) {
                        return {
                            ...tvKey,
                            ...action.payload
                        };
                    }
                    return tvKey;
                });
        
        case DELETE_TV_KEY:
            return state.filter((item) => {
                return item.id !== action.payload;
            });

        default:
            return state;
    }

};

export default getItems;